/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Research_Mock_1Inputs */

const en_cap_research_mock_1 = /** @type {(inputs: Cap_Research_Mock_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most clinics take bookings by phone; few offer online booking.`)
};

const lv_cap_research_mock_1 = /** @type {(inputs: Cap_Research_Mock_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lielākā daļa klīniku pieraksta pa tālruni, tiešsaistes pierakstu piedāvā retā.`)
};

/**
* | output |
* | --- |
* | "Most clinics take bookings by phone; few offer online booking." |
*
* @param {Cap_Research_Mock_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_research_mock_1 = /** @type {((inputs?: Cap_Research_Mock_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Research_Mock_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_research_mock_1(inputs)
	return en_cap_research_mock_1(inputs)
});